<!-- eslint-disable -->
<template lang="pug">
    div(v-if="!areSchoolsBlocked && !blockedAccesses.includes('mentalArithmetic')")
        map-component(:location="location" :modal="modal" :video="video")
    div.block-message(v-else) {{ $i18n.t('errors.page_not_access') }}
</template>

<script>
    /*eslint-disable*/
    import CsLoader from '../../../elements/CsLoader.vue'
    import courseAccesses from "../../../utils/user/courseAccesses"
    import BillingBlockMixin from '../../../utils/user/BillingBlockMixin';
    import { mapState } from 'vuex';

    export default {
        mixins: [courseAccesses, BillingBlockMixin],
        props: {
            modal: {
                type: Boolean,
                default: false
            },
            video: {
                type: Boolean,
                default: false
            },
            location: String
        },
        mounted () {
            if (!this.courseAllowMap) {
                this.$router.push({ name: '403' });
            }
            document.body.classList.add('map-background')
        },
        beforeDestroy () {
            document.body.classList.remove('map-background');
        },
        components: {
            MapComponent: () => ({
                component: import('./MapComponent.vue'),
                loading: CsLoader,
                delay: 0
            }),
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
        }
    }
</script>

<style lang="scss" scoped>
    .block-message {
        text-align: center;
        font-family: Boomboom, serif;
        color: $x-color-white;
        font-size: 22px;
        white-space: nowrap;
        @include media ($sm) {
            font-size: 48px;
        }
        @include media ($lg) {
            font-size: 60px;
        }
    }
</style>
